$('#bannerHome').slick({
  infinite: true,
  arrows: false,
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipe: true,
  autoplay: true,
  autoplaySpeed: 5000,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        dots: false,
        arrows: true,
        prevArrow: '.backBannerH',
        nextArrow: '.nextBannerH',
        swipe: false,
      }
    }
  ]
});

$('#slickTeam2').slick({
  dots: true,
  arrows: false,
  adaptiveHeight: true,
  mobileFirst: true,
  responsive: [
  {
    breakpoint: 1000,
    settings: {
      arrows: true,
      dots: false,
      prevArrow: '.backTeam',
      nextArrow: '.nextTeam'
    }
  },
  ]
});

$('#slickTeam').slick({
  dots: true,
  arrows: false,
  adaptiveHeight: true,
  mobileFirst: true,
  responsive: [
  {
    breakpoint: 760,
    settings: {
      dots: true,
      slidesToShow: 2,
    }
  },
  {
    breakpoint: 1020,
    settings: {
      slidesToShow: 4,
    }
  },
  {
    breakpoint: 1200,
    settings: {
      slidesToShow: 4,
      arrows: true,
      dots: false,
      prevArrow: '.backTeam',
      nextArrow: '.nextTeam'
    }
  },
  ]
});

$('#slickClients').slick({
  arrows: false,
  speed: 500,
  fade: true,
  autoplay: true,
  autoplaySpeed: 3000,
  mobileFirst: true,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 760,
      settings: {
        fade: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 1020,
      settings: {
        fade: false,
        slidesToShow: 4,
      }
    },
  ]
});

$('#slickServices').slick({
  arrows: false,
  dots: true,
  mobileFirst: true,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 760,
      settings: {
        fade: false,
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 1020,
      settings: {
        fade: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 1200,
      settings: 'unslick'
    },
  ]
});

$('#interestPosts').slick({
  slidesToShow: 1,
  arrows: false,
  mobileFirst: true,
  centerMode: true,
  // variableWidth: true,
  responsive: [
    {
      breakpoint: 760,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 1020,
      settings: 'unslick'
    },
  ]
});